module.exports = __webpack_public_path__ + "img/barkerj.f5037054.jpg";